<template>
    <div class="student__app">
        <div v-if="formStatus === 'open'" class="student__sci">
            <div class="container student__sci-container">
                <div class="row justify-content-center align-items-center">
                    <div class="student__sci-form">
                        <div class="student__sub-header">
                            <div class="student__logo">
                                <img src="../../assets/icons/icon-128x128.png" alt="Opt-Outs Logo"> Opt-Outs
                            </div>
                        </div>
                        <div v-if="user.commonName" class="student__desc">
                            Hello, {{ user.commonName }}!
                        </div>
                        <SCIform :user="user" :formStatus="formStatus" :expiringFields="expiringFields"></SCIform>
                    </div>
                </div>
            </div>
        </div>
        <student-closed v-else></student-closed>
    </div>
</template>

<script>
import SCIform from '../Form/v1/Form';
import StudentClosed from './Closed';

export default {
    name: 'student',
    props: {
        expiringFields: {
            type: Array
        },
        formStatus: {
            type: String,
            required: true
        },
        user: {
            type: Object,
            required: true
        }
    },
    components: {
        SCIform,
        StudentClosed
    }
}
</script>

<style>
html {
    background: url('../../assets/background/student.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    min-height: 100%;
}

body {
    background: transparent;
}

.opt__out {
    color: #d91e18;
    text-decoration: line-through;
}

.student__content {
    font-size: 1.25rem;
    margin: 1rem;
}

.student__desc {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: .5rem;
}

.student__header {
    font-size: 3rem;
    font-weight: bold;
    letter-spacing: 2px;
    line-height: 1.2;
    text-transform: uppercase;
}

.student__logo img {
    height: 42px;
}

.student__sci {
    color: #2c2c2c;
}

.student__sci-container {
    padding-bottom: 3rem;
    padding-top: 5rem;
}

.student__sci-form {
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);
    -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);
    margin-left: 1rem;
    margin-right: 1rem;
    padding: 1.25rem !important;
}

.student__sub-header {
    font-family: 'Roboto', serif;
    font-size: 2rem;
    line-height: 1.2;
    margin-bottom: 1rem;
}
</style>
